import React from 'react';
import moment from 'moment';
import { TabelaFichaRoc } from './TabelaFichaRoc';
import CampoFicha from './CampoFicha';
import mascaras from '../../../../helpers/mascaras';
 

const formatarData = data => data ? moment(data).format("DD/MM/YYYY") : "";

const formatarMedida = (valor, unidade) => valor || valor === 0 ? `${valor}${unidade}` : "";

export default function FichaRoc({ ficha }) {
    if (!ficha) return null;
    return (
        <div>
            <h5 className="fw-bold mt-3">Ficha do Transportador — Protocolo {ficha.numeroProtocolo}</h5>

            <div className="row">
                <CampoFicha rotulo="Razão Social" valor={ficha.empresa?.razaoSocial} />
                <CampoFicha rotulo="Nome Fantasia" valor={ficha.empresa?.nomeFantasia} />
                <CampoFicha rotulo="Responsável" valor={ficha.responsavel?.nome} />

                <CampoFicha rotulo="CNPJ" valor={mascaras.cpfcnpjMask(ficha.empresa?.cpf_Cnpj)} />
                <CampoFicha rotulo="Categoria" valor={ficha.categoriaDescricao} />
                
                <CampoFicha rotulo="Código de Cadastro" valor={ficha.empresa?.codigoCadastro} />
                <CampoFicha rotulo="CCM" valor={ficha.empresa?.ccm} />

                <CampoFicha rotulo="Endereço" valor={ficha.empresa?.enderecoCompleto} largura="col-12" />

                <CampoFicha rotulo="Fim de vigência" valor={formatarData(ficha.empresa?.dataFimVigencia)} />

                <CampoFicha rotulo="Email" valor={ficha.responsavel?.email} />
                <CampoFicha rotulo="Telefone" valor={ficha.responsavel?.telefone} />

                <CampoFicha rotulo="Celular" valor={ficha.responsavel?.celular} />
            </div>

            <h6 className="fw-bold mt-3">Veículos</h6>
            <TabelaFichaRoc
                cabecalhos={["Placa", "Tipo", "Capacidade de Carga", "Validade da Vistoria", "Status"]}
                linhas={(ficha.veiculos ?? []).map(v => [v.placa, v.tipo, formatarMedida(v.capacidadeCarga, "kg"), formatarData(v.dataValidadeVistoria), v.status])}
            />

            <h6 className="fw-bold mt-3">Locais de Guarda</h6>
            <TabelaFichaRoc
                cabecalhos={["Endereço", "Status"]}
                linhas={(ficha.locaisGuarda ?? []).map(l => [l.enderecoCompleto, l.status])}
            />

            <h6 className="fw-bold mt-3">Locais de Destinação</h6>
            <TabelaFichaRoc
                cabecalhos={["Razão Social", "CNPJ", "Endereço", "Status"]}
                linhas={(ficha.locaisDestino ?? []).map(l => [l.razaoSocial, l.cnpj, l.enderecoCompleto, l.status])}
            />

            <h6 className="fw-bold mt-3">Equipamentos</h6>
            <TabelaFichaRoc
                cabecalhos={["Tipo", "Número", "Capacidade de Volume", "Status"]}
                linhas={(ficha.equipamentos ?? []).map(e => [e.tipo, e.numeroEquipamento, formatarMedida(e.capacidadeVolume, "m³"), e.status])}
            />

            <h6 className="fw-bold mt-3">Classes de Resíduo</h6>
            <p style={{ fontSize: 14 }}>{(ficha.classesResiduo ?? []).join(", ")}</p>
        </div>
    );
}
